import { ChecklistItem } from '../components/ChecklistCard'

export interface ChecklistTemplate {
  id: string
  generateTitle: (data: Record<string, string>) => string
  generateItems: (data: Record<string, string>) => ChecklistItem[]
}

export const checklistTemplates: Record<string, ChecklistTemplate> = {
  'school-enrollment': {
    id: 'school-enrollment',
    generateTitle: (data) =>
      `Iscrizione scuola per ${data.childName || 'bambino'}`,
    generateItems: (data) => [
      {
        id: 't-1',
        text: 'Raccogliere documenti necessari (carta identità, codice fiscale)',
        completed: false,
      },
      {
        id: 't-2',
        text: 'Richiedere certificato nascita in Comune',
        completed: false,
      },
      {
        id: 't-3',
        text: 'Preparare certificato vaccinazioni (ASL)',
        completed: false,
      },
      {
        id: 't-4',
        text: 'Compilare modulo iscrizione online o cartaceo',
        completed: false,
      },
      {
        id: 't-5',
        text: 'Allegare foto tessera recente',
        completed: false,
      },
      {
        id: 't-6',
        text: `Inviare domanda entro ${data.deadline ? new Date(data.deadline).toLocaleDateString('it-IT') : 'la scadenza'}`,
        completed: false,
      },
      {
        id: 't-7',
        text: 'Attendere conferma di accettazione dalla scuola',
        completed: false,
      },
      ...(data.notes
        ? [
            {
              id: 't-8',
              text: `Note: ${data.notes}`,
              completed: false,
            },
          ]
        : []),
    ],
  },

  'doctor-change': {
    id: 'doctor-change',
    generateTitle: (data) =>
      `Cambio pediatra per ${data.childName || 'bambino'}`,
    generateItems: (data) => [
      {
        id: 't-1',
        text: 'Scegliere nuovo pediatra dalla lista ASL',
        completed: false,
      },
      {
        id: 't-2',
        text: 'Verificare disponibilità del nuovo pediatra',
        completed: false,
      },
      {
        id: 't-3',
        text: 'Raccogliere documenti (tessera sanitaria, carta identità)',
        completed: false,
      },
      {
        id: 't-4',
        text: 'Recarsi presso ASL con documenti',
        completed: false,
      },
      {
        id: 't-5',
        text: 'Compilare modulo di cambio medico',
        completed: false,
      },
      {
        id: 't-6',
        text: 'Richiedere cartella clinica al vecchio pediatra',
        completed: false,
      },
      {
        id: 't-7',
        text: `Completare cambio entro ${data.deadline ? new Date(data.deadline).toLocaleDateString('it-IT') : 'la scadenza'}`,
        completed: false,
      },
      {
        id: 't-8',
        text: 'Fissare primo appuntamento con nuovo pediatra',
        completed: false,
      },
    ],
  },

  'passport-renewal': {
    id: 'passport-renewal',
    generateTitle: (data) =>
      `Rinnovo passaporto per ${data.childName || 'bambino'}`,
    generateItems: (data) => [
      {
        id: 't-1',
        text: 'Fare 2 foto tessera recenti (sfondo bianco)',
        completed: false,
      },
      {
        id: 't-2',
        text: 'Raccogliere documenti identità (carta identità, codice fiscale)',
        completed: false,
      },
      {
        id: 't-3',
        text: 'Preparare passaporto vecchio (se presente)',
        completed: false,
      },
      {
        id: 't-4',
        text: 'Prenotare appuntamento in Questura online',
        completed: false,
      },
      {
        id: 't-5',
        text: 'Pagare marca da bollo (€73.50)',
        completed: false,
      },
      {
        id: 't-6',
        text: 'Presentarsi in Questura con bambino e documenti',
        completed: false,
      },
      {
        id: 't-7',
        text: `Ritirare passaporto entro ${data.deadline ? new Date(data.deadline).toLocaleDateString('it-IT') : 'la scadenza'}`,
        completed: false,
      },
      ...(data.notes
        ? [
            {
              id: 't-8',
              text: `Documenti già pronti: ${data.notes}`,
              completed: false,
            },
          ]
        : []),
    ],
  },

  'sports-enrollment': {
    id: 'sports-enrollment',
    generateTitle: (data) =>
      `Iscrizione ${data.sportName || 'sport'} per ${data.childName || 'bambino'}`,
    generateItems: (data) => [
      {
        id: 't-1',
        text: `Cercare società sportive per ${data.sportName || "l'attività"} in zona`,
        completed: false,
      },
      {
        id: 't-2',
        text: 'Richiedere informazioni su orari e costi',
        completed: false,
      },
      {
        id: 't-3',
        text: 'Prenotare lezione di prova gratuita',
        completed: false,
      },
      {
        id: 't-4',
        text: 'Richiedere certificato medico sportivo',
        completed: false,
      },
      {
        id: 't-5',
        text: 'Compilare modulo iscrizione società sportiva',
        completed: false,
      },
      {
        id: 't-6',
        text: 'Pagare quota associativa e assicurazione',
        completed: false,
      },
      {
        id: 't-7',
        text: `Completare iscrizione entro ${data.deadline ? new Date(data.deadline).toLocaleDateString('it-IT') : 'la scadenza'}`,
        completed: false,
      },
      {
        id: 't-8',
        text: 'Acquistare abbigliamento/attrezzatura necessaria',
        completed: false,
      },
    ],
  },
}

export function generateChecklist(
  templateId: string,
  data: Record<string, string>,
): { title: string; items: ChecklistItem[] } | null {
  const template = checklistTemplates[templateId]
  if (!template) return null

  return {
    title: template.generateTitle(data),
    items: template.generateItems(data),
  }
}
